module.exports = __webpack_public_path__ + "img/08.9a76e9a7.jpg";